<div class="flex flex-col flex-auto md:w-160 md:min-w-160 max-h-160 -m-6 overflow-y-auto">

	<!-- Header -->
	<div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-accent text-on-primary">
		<div class="text-lg font-medium">Register new user</div>
		<button (click)="cancel()" mat-icon-button [tabIndex]="-1">
			<mat-icon class="text-current" [svgIcon]="'heroicons_outline:x'"></mat-icon>
		</button>
	</div>

	<div class="flex flex-col gap-4 p-6">

		<form [formGroup]="registerForm" class="grid grid-cols-2 gap-4">

			<mat-form-field>
				<mat-label>First Name</mat-label>
				<input matInput formControlName="firstName" placeholder="Enter first name">
				<mat-error *ngIf="registerForm.get('firstName')?.hasError('required')">
					First name is required
				</mat-error>
			</mat-form-field>

			<mat-form-field>
				<mat-label>Last Name</mat-label>
				<input matInput formControlName="lastName" placeholder="Enter last name">
				<mat-error *ngIf="registerForm.get('lastName')?.hasError('required')">
					Last name is required
				</mat-error>
			</mat-form-field>

			<mat-form-field class="col-span-2">
				<mat-label>Email</mat-label>
				<input matInput type="email" formControlName="email" placeholder="Enter email">
				<mat-error *ngIf="registerForm.get('email')?.hasError('email')">
					Please enter a valid email address
				</mat-error>
				<mat-error *ngIf="registerForm.get('email')?.hasError('required')">
					Email is required
				</mat-error>
			</mat-form-field>

			<div class="flex flex-col gap-2">
				<mat-label class="font-medium">
					Password *
				</mat-label>
				<div
					class="flex gap-2 justify-between items-center bg-gray-100 p-2 px-4 rounded-md border border-gray-200">
					<code class="text-gray-600 leading-none">
						{{userPassword}}
					</code>

					<button mat-icon-button type="button" (click)="copyPasswordToClipboard()"
						[matTooltip]="'Copy to clipboard'" class="ml-2">
						<mat-icon svgIcon="heroicons_outline:clipboard-copy"
							class="icon-size-5 text-gray-600"></mat-icon>
					</button>
				</div>
			</div>

			<div class="flex flex-col justify-end">
				<div class="flex gap-2 border rounded-md p-2">
					<mat-icon class="icon-size-4" svgIcon="heroicons_outline:information-circle"></mat-icon>
					On first login, the user will be prompted to create a new password.
				</div>
			</div>

			<div class="col-span-2 flex flex-col gap-2">
				<mat-label class="font-medium">
					Base user access *
				</mat-label>
				<group-selector formControlName="groups" [multiple]="true"></group-selector>
				<div *ngIf="registerForm.get('groups')?.hasError('required') && registerForm.get('groups')?.touched"
					class="text-red-500 text-sm mt-2">
					Please select at least one user group
				</div>
			</div>

		</form>

		<div class="flex gap-4 justify-between mt-8">

			<button mat-stroked-button (click)="cancel()">Cancel</button>
			<button mat-raised-button color="primary" (click)="register()"
				[disabled]="registerForm.invalid || registering">
				<span *ngIf="!registering">Register User</span>
				<span *ngIf="registering" class="flex items-center gap-2">
					<div class="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
					Registering...
				</span>
			</button>
		</div>

	</div>

</div>
